// auditStatuses.js

export const STATUS_LABEL = {
  DRAFT:              'New Draft Created',
  SUBM:               'Submitted to NAIC',
  SUBM_ERR:           'Error in Submission',
  CONTRL_ACK:         'Successful Acknowledgment',
  CONTRL_NACK:        'Failed Acknowledgement',
  ACT:                'Assessment Complete',
  ACW:                'Assessment Complete with warning',
  DNL:                'Do Not Load',
  EXP:                'Filing Expiry',
  PSF:                'Pending Sub-filing',
  RFI:                'Request for Information',
  CANCEL_CONTRL_ACK:  'Cancellation Successful',
  CANCEL_CONTRL_NACK: 'Cancellation Failed',
  UPDATE_DRAFT:       'Updated Filing Draft Created',
  ATTACH_ACK:         'Attachment Successfully Received by NAIC',
  ATTACH_NACK:        'Attached Submission to NAIC is unsuccessful',
  PROC:               'Processing'
}

export const STATUS_COLOR = {
  DRAFT: { bg: '#e3f2fd', text: '#1565c0' },
  SUBM: { bg: '#e8f5e9', text: '#2e7d32' },
  SUBM_ERR: { bg: '#fce4ec', text: '#c62828' },
  CONTRL_ACK: { bg: '#e8f5e9', text: '#2e7d32' },
  CONTRL_NACK: { bg: '#fce4ec', text: '#c62828' },
  ACT: { bg: '#e8f5e9', text: '#2e7d32' },
  ACW: { bg: '#fff8e1', text: '#f57f17' },
  DNL: { bg: '#fce4ec', text: '#c62828' },
  EXP: { bg: '#fafafa', text: '#616161' },
  PSF: { bg: '#fff8e1', text: '#f57f17' },
  RFI: { bg: '#fff3e0', text: '#e65100' },
  CANCEL_CONTRL_ACK: { bg: '#f3e5f5', text: '#6a1b9a' },
  CANCEL_CONTRL_NACK: { bg: '#fce4ec', text: '#c62828' },
  UPDATE_DRAFT: { bg: '#e3f2fd', text: '#1565c0' },
  ATTACH_ACK: { bg: '#e8f5e9', text: '#2e7d32' },
  ATTACH_NACK: { bg: '#fce4ec', text: '#c62828' },
  PROC: { bg: '#e8eaf6', text: '#3949ab' }
}

export const SUB_STATUS_LABEL = {
  FD: 'First Draft',
  CI: 'Connectivity Issue',
  SD: 'Subsequent Draft'
}

// Helper
export function getStatusLabel(code) {
  return STATUS_LABEL[code] || code || '—'
}

export function getSubStatusLabel(code) {
  return SUB_STATUS_LABEL[code] || code || null
}
